export default "__VITE_ASSET__BjPZNzzf__"